import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItFailsSection } from '../components/WhyItFailsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0e1a] text-white selection:bg-[#00d9ff]/30 selection:text-white pb-20 md:pb-0" data-id="element-316">
      <Hero data-id="element-317" />
      <ProblemSection data-id="element-318" />
      <WhyItFailsSection data-id="element-319" />
      <SolutionSection data-id="element-320" />
      <IncludesSection data-id="element-321" />
      <HowItWorksSection data-id="element-322" />
      <AudienceSection data-id="element-323" />
      <ProofSection data-id="element-324" />
      <FAQSection data-id="element-325" />
      <PricingCTA data-id="element-326" />
      <Footer data-id="element-327" />
    </main>;
}